<script setup lang="ts">
import { computed, ref } from 'vue';
import type { LiqpayCheckoutResponse } from 'src/types/strapi/customTypes';
import BButton from 'src/shared/components/base/BButton/BButton.vue';

interface Props {
  planData: LiqpayCheckoutResponse;
}

const props = defineProps<Props>();

const emits = defineEmits<{
  checkout: [];
}>();

const isLoading = ref(false);

const isApiRequest = computed(() => {
  return (
    props.planData?.liqPayPayment?.url === 'https://www.liqpay.ua/api/request'
  );
});

function handleCheckout(event: MouseEvent) {
  // Prevent default form submission if it's an API request
  if (isApiRequest.value) {
    isLoading.value = true;
    event.preventDefault();
    emits('checkout');
  }
}
</script>

<template>
  <q-form
    :action="!isApiRequest && planData?.liqPayPayment?.url"
    method="POST"
    accept-charset="UTF-8"
  >
    <input
      type="hidden"
      name="data"
      :value="planData?.liqPayPayment?.data"
    />
    <input
      type="hidden"
      name="signature"
      :value="planData?.liqPayPayment?.signature"
    />
    <slot></slot>
    <BButton
      v-if="planData?.liqPayPayment"
      :type="
        planData?.liqPayPayment?.action === 'subscribe' ? 'submit' : 'button'
      "
      size="sm"
      color="accent"
      text-color="dark"
      :label="$t('CHECKOUT')"
      :loading="isLoading"
      :disabled="isLoading"
      @click="handleCheckout"
    />
  </q-form>
</template>
